import {
  authProviderAtom,
  type AuthProviderType,
  authStore
} from '@/features/auth/atoms'

const _authProviderType = {
  COGNITO: {
    loginPath: '/login/cognito'
  },
  AUTH0: {
    loginPath: '/login/'
  }
} satisfies Record<
  AuthProviderType,
  {
    loginPath: string
  }
>

const type = authStore.get(authProviderAtom)
export const loginPath = type ? _authProviderType[type].loginPath : '/login/'
